import React from 'react'

import Text from '@cinch/oxd-components/text/src'
import { Tertiary as TertiaryButton } from '@cinch/oxd-components/button/src'

import styles from './banner-mobile-nav.module.css'

interface Props {
  text: string
  buttonText: string
  handleClick: () => void
  tag?: Cinch.AnalyticsTag
}

const BannerMobileNav: React.FC<Props> = ({ text, buttonText, handleClick, tag }) => (
  <div className={styles.container}>
    <Text className={styles.text}>{text}</Text>
    <div className={styles.buttonContainer}>
      <TertiaryButton onClick={handleClick} size={'mini'} tag={tag}>
        {buttonText}
      </TertiaryButton>
    </div>
  </div>
)

export default BannerMobileNav
